/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It willbe overwritten.

//let url = "http://localhost:8080/kawagoe/Taiken"
let url = "http://localhost:8080/"

/* 本番環境 */
/*
const aws_cognito_identity_pool_id = "ap-northeast-1:7cccd05d-44bd-4c61-9e06-15cc02bc823c"
const aws_user_pools_id = "ap-northeast-1_3OHgw3311"
const aws_user_pools_web_client_id = "3gi6k740mjirrs9asa5qro381e"
const domain = "ap-northeast-13ohgw3311.auth.ap-northeast-1.amazoncognito.com"
//url += ",https://www.volukatsu-yell.jp/kawagoe/Taiken,https://www.volukatsu-yell.jp/tsurugashima/Taiken"
url += ",https://www.volukatsu-yell.jp/"
*/
/* 開発環境 */
const aws_cognito_identity_pool_id =  "ap-northeast-1:d026f009-3ac3-4eef-8b41-4da0d048f8de"
const aws_user_pools_id = "ap-northeast-1_6hWWd14Fy"
const aws_user_pools_web_client_id = "athmhjnaevim1oel849bvg145"
const domain = "volukatsu.auth.ap-northeast-1.amazoncognito.com"
//url += ",https://www.volukatsu-taiken.net/kawagoe/Taiken,https:///www.volukatsu-taiken.net/tsurugashima/Taiken"
url += ",https://www.volukatsu-taiken.net/"

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": aws_cognito_identity_pool_id,
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id":aws_user_pools_id ,
    "aws_user_pools_web_client_id": aws_user_pools_web_client_id,
    "oauth": {
        "domain": domain,
        "scope": [
            "openid", "email", "aws.cognito.signin.user.admin" ],
        "redirectSignIn": url,
        "redirectSignOut": url,
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "Google", "Apple", "line",
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    // デバッグ設定を追加
    "aws_appsync_detailedErrors": true, // GraphQL エラーの詳細情報をログに出力するかどうか
    "aws_appsync_logLevel": "VERBOSE" // ログの詳細度レベル (VERBOSE, INFO, WARN, ERROR)
};


export default awsmobile;